export const fonts = {
  body: "Outfit, system-ui, sans-serif",
  heading: "Outfit, sans-serif",
  mono: "monospace",
};
